module.exports = __webpack_public_path__ + "static/media/my_profile.59c91c57.webp";